// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"82fb03a6","239":"44273a20","367":"177c6bed","383":"67e60af2","455":"535f1e63","492":"cb50ec35","511":"d50c3e91","620":"829d7471","680":"41c7b76c","703":"059b0598","717":"ef19f4fb","815":"fb999fbe","830":"e26d2c36","870":"be92fd35","977":"20277855"}[chunkId] + ".chunk.js";
};